import React from 'react';

import { CarPaymentColorIcon, CautionColorIcon, NameTransferColorIcon } from '@/components/Icon';

const TransferGuideView = () => {
  return (
    <div className="bg-gray-1">
      <div className="flex flex-col items-center py-10">
        <p className="text-gray-11 text-[20px] font-medium text-center mb-[30px]">
          구매·판매할 차량 결정 후
          <br />
          어떤 절차를 거쳐야할지 고민된다면
        </p>
        <p className="text-[24px] font-bold text-center leading-[1.5]">
          <span className="inline-block shadow-[0_6px_0_0_#afcbff] leading-[17px]">서류 이전 대행 서비스로</span>
          <br />한 번에 해결하세요
        </p>
        <div className="w-full flex justify-center items-center max-w-[155px] max-h[156px] mt-[20px]">
          <img
            src="https://zigtruck-service-public-image.s3.ap-northeast-2.amazonaws.com/transfer_agency_service.png"
            alt="구매 동행 서비스 트럭 이미지"
            className="w-full"
          />
        </div>
      </div>

      <div className="flex flex-col items-center justify-center">
        <div className="flex flex-col gap-[18px]">
          <div className="flex items-center text-gray-12 font-semibold leading-[20px]">
            <NameTransferColorIcon width={30} height={30} />
            <div className="ml-[6px]">
              <div className="text-[14px] text-gray-7 font-medium">명의 이전에 필요한</div>
              <div className="text-[16px] font-bold">명의 이전 준비서류와</div>
            </div>
          </div>
          <div className="flex items-center text-gray-12 font-semibold leading-[20px]">
            <CarPaymentColorIcon width={36} height={36} />
            <div className="ml-[6px]">
              <div className="text-[14px] text-gray-7 font-medium">구매·판매할 차량의</div>
              <div className="text-[16px] font-bold">차량 대금 처리부터</div>
            </div>
          </div>
          <div className="flex items-center text-gray-12 font-semibold leading-[20px]">
            <CautionColorIcon width={33} height={33} />
            <div className="ml-[6px]">
              <div className="text-[14px] text-gray-7 font-medium">안전한 직거래 매칭을 위한</div>
              <div className="text-[16px] font-bold">거래 시 유의사항까지</div>
            </div>
          </div>
        </div>

        <div className="bg-gray-1 py-[46px] px-4 text-gray-8 text-center text-pretty break-keep">
          서류 이전 대행 서비스는 <br className="hidden xxs:block" />
          화물차 직거래 매칭 시<br />
          고객님들의 안전한 거래를 위해
          <br />
          도움을 드리는 서비스입니다.
        </div>
        <div className="text-gray-6 text-[12px] mb-[46px]">※ 해당 서비스는 유료 서비스입니다.</div>
      </div>
    </div>
  );
};

export default TransferGuideView;
